/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Referral_Step1_TitleInputs */

const tr_landing_referral_step1_title = /** @type {(inputs: Landing_Referral_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linkinizi paylaşın`)
};

const en_landing_referral_step1_title = /** @type {(inputs: Landing_Referral_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share your link`)
};

const de_landing_referral_step1_title = /** @type {(inputs: Landing_Referral_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen Sie Ihren Link`)
};

const ru_landing_referral_step1_title = /** @type {(inputs: Landing_Referral_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поделитесь ссылкой`)
};

/**
* | output |
* | --- |
* | "Share your link" |
*
* @param {Landing_Referral_Step1_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_referral_step1_title = /** @type {((inputs?: Landing_Referral_Step1_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Referral_Step1_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_referral_step1_title(inputs)
	if (locale === "de") return de_landing_referral_step1_title(inputs)
	if (locale === "ru") return ru_landing_referral_step1_title(inputs)
	return tr_landing_referral_step1_title(inputs)
});